<template>
  <a
    v-if="isTeamMember"
    rel="noopener"
    target="_blank"
    aria-label="Edit in Directus"
    class="help-center-directus-bunny__component"
    :href="adminUrl"
  >
    <i class="help-center-directus-bunny__icon far fa-rabbit-running" />
  </a>
</template>

<script setup>
import useHelpCenterVisitor from 'help-center/composables/useHelpCenterVisitor'

defineProps({
  adminUrl: {
    type: String,
    required: true
  }
})

const { isTeamMember } = useHelpCenterVisitor()
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-directus-bunny {
  &__component {
    @include help-center-accent-link;
    display: flex;
    padding: 4px;
  }

  &__icon {
    @include help-center-icon(16);
  }
}
</style>
